import { render, staticRenderFns } from "./SendChannelsModal.vue?vue&type=template&id=64e9cbfa&scoped=true"
import script from "./SendChannelsModal.vue?vue&type=script&lang=js"
export * from "./SendChannelsModal.vue?vue&type=script&lang=js"
import style0 from "./SendChannelsModal.vue?vue&type=style&index=0&id=64e9cbfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e9cbfa",
  null
  
)

export default component.exports